module.exports = __webpack_public_path__ + "img/screen-3.a9224d9c.jpg";